var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{staticClass:"mb-4",attrs:{"id":"back-button"},on:{"click":_vm.goBack}},[_vm._v("arrow_back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }